export const decodeJwtPayload = (token) => {
  if (!token) return null;
  const parts = String(token).split('.');
  if (parts.length < 2) return null;

  try {
    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const padLength = (4 - (base64.length % 4)) % 4;
    const padded = base64 + '='.repeat(padLength);
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
};

export const getUserRoleFromToken = (token) => {
  const payload = decodeJwtPayload(token);
  return payload?.role || 'user';
};

export const getUserIdFromToken = (token) => {
  const payload = decodeJwtPayload(token);
  return payload?.userId ?? null;
};

export const getActorUserIdFromToken = (token) => {
  const payload = decodeJwtPayload(token);
  return payload?.actorUserId ?? payload?.userId ?? null;
};

export const getSubscriptionTypeFromToken = (token) => {
  const payload = decodeJwtPayload(token);
  return payload?.subscriptionType || 'free';
};

export const getIsAccountManagerFromToken = (token) => {
  const payload = decodeJwtPayload(token);
  return Boolean(payload?.isAccountManager);
};
